export default __webpack_public_path__ + "static/posy-27c805a216e721fb481b35daaffc4d8c.jpg";